

export function convertStyle(style, text){
    if(!text){
        return "";
    }
    const result_arr = [];
    const str_arr = text.split(" ");

    str_arr.map((item, index)=>{
        result_arr.push(item);
        if(style[item]){
            result_arr.push(style[item]);
        }
    });

    return result_arr.join(" ");
}